import { ExtendedNodeData, TreeItem } from 'react-sortable-tree'
import { RemoveAbleItemProps } from 'ts/interfaces'
import { getNodeStyle, getNodeTitle } from '../PresetNodeRenderHelper'
import { getNodeActions } from './nodeActions'

interface NodePropsGeneratorProps {
    presetId: number
    nodeActionButtonSx: any
    reRenderCallback: () => void
    setRemoveableItem: (item: RemoveAbleItemProps | null) => void
    handleNodeSelection: (node: TreeItem) => void
}

export const createNodePropsGenerator = ({
    presetId,
    nodeActionButtonSx,
    reRenderCallback,
    setRemoveableItem,
    handleNodeSelection
}: NodePropsGeneratorProps) => {
    return (extendedNode: ExtendedNodeData) => {
        const node = extendedNode?.node

        // Add path to node object
        node.path = extendedNode.path

        return {
            style: getNodeStyle(node),
            title: getNodeTitle(node),
            buttons: getNodeActions({
                node,
                presetId,
                nodeActionButtonSx,
                reRenderCallback,
                setRemoveableItem
            }),
            onClick: () => {
                handleNodeSelection(node)
            }
        }
    }
}
